import { ClientOnly } from 'components/elements/ClientOnly'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducer'

export const withAuth = <P extends Record<string, unknown>>(
    WrappedComponent: React.ComponentType<any>,
    requiresAuthentication: boolean,
    requiresKnower: boolean
) => {
    // eslint-disable-next-line react/display-name
    return (props: P) => {
        if (!requiresAuthentication) {
            return (
                <ClientOnly>
                    <WrappedComponent {...props} />
                </ClientOnly>
            )
        }

        if (typeof window === 'undefined') {
            return null
        }

        const router = useRouter()
        const authenticatedUser = useSelector((state: AppState) => state.user)
        const authenticatedKnower = useSelector((state: AppState) => state.knower)

        useEffect(() => {
            // Prevent showing several toast messages to the user
            if (!router.isReady) return

            if (!authenticatedUser) {
                router.push(`/auth/signin?redirect=${router.asPath}`)
            } else if (requiresKnower && !authenticatedKnower) {
                router.push('/')
            }
        }, [authenticatedUser, authenticatedKnower, router])

        if (!authenticatedUser || (requiresKnower && !authenticatedKnower)) {
            return null
        }

        return (
            <ClientOnly>
                <WrappedComponent {...props} />
            </ClientOnly>
        )
    }
}
